import { HttpService as Http, HttpError, HttpRequestOptions, HttpResponse, HttpServiceInterface } from '@philips-internal/oswald-ui-core/lib/services';

interface HttpServiceResponse<R> extends Omit<Response, 'body'> {
  body: R;
}

interface HttpServiceError<R = unknown> extends Error {
  response?: HttpServiceResponse<R>;
}

function httpGet<T>(endpoint: string, endpointParameters?: Record<string, unknown>, options?: HttpRequestOptions): Promise<HttpResponse<T>> {
  return Http.get<T>(endpoint, endpointParameters, options).catch(e => handleHttpServiceFailure(e));
}

function httpPost<T>(endpoint: string, endpointParameters?: Record<string, unknown>, options?: HttpRequestOptions): Promise<HttpResponse<T>> {
  return Http.post<T>(endpoint, endpointParameters, options).catch(e => handleHttpServiceFailure(e))
}

function httpPut<T>(endpoint: string, endpointParameters?: Record<string, unknown>, options?: HttpRequestOptions): Promise<HttpResponse<T>> {
  return Http.put<T>(endpoint, endpointParameters, options).catch(e => handleHttpServiceFailure(e));
}

function httpDelete<T>(endpoint: string, endpointParameters?: Record<string, unknown>, options?: HttpRequestOptions): Promise<HttpResponse<T>> {
  return Http.delete<T>(endpoint, endpointParameters, options).catch(e => handleHttpServiceFailure(e));
}

function handleHttpServiceFailure<T>(e: HttpError): Promise<HttpResponse<T>> {
  const response = e.response;

  if (!response) {
    return Promise.reject(e);
  }

  return response.json().then<HttpResponse<T>>((data: T) => {
    const errorResponse: HttpServiceError<T> = {
      ...e,
      response: {
        ...response,
        body: data,
        headers: response.headers,
        ok: response.ok,
        status: response.status,
        statusText: response.statusText,
      }
    }

    return Promise.reject(errorResponse);
  }).catch(() => {
    return Promise.reject(e);
  });
}

const PatientHttpService: HttpServiceInterface = {
  ...Http,
  delete: httpDelete,
  get: httpGet,
  post: httpPost,
  put: httpPut,
}

export {
  PatientHttpService,
  HttpServiceError,
  HttpServiceResponse
}